import { Directive, HostBinding, Input, OnInit, Host } from '@angular/core';

@Directive({
  selector: '[sukaGrid]'
})
export class GridDirective {
  @HostBinding('class.grid') baseClass = true;
}

@Directive({
  selector: '[sukaRow]'
})
export class RowDirective {
  @HostBinding('class.row') baseClass = true;
  /**
   * Set to `true` for no gutters between columns.
   */
  @HostBinding('class.no-gutters') @Input() noGutters = false;
  /**
   * Set to `true` to make the columns distribute their height accordingly to the row total height.
   */
  @HostBinding('class.row-deck') @Input() rowDeck = false;
}

@Directive({
  selector: '[sukaCol]'
})
export class ColumnDirective implements OnInit {
  /**
   * Sets the class
   */
  @Input() class = '';

  /**
   * Object that sets the column numbers according to the breakpoint.
   * Breakpoints can be:<br>
   * - xs: From 0px<br>
   * - sm: From 576px<br>
   * - md: From 768px<br>
   * - lg: From 992px<br>
   * - xl: From 1200px<br>
   * - xxl: From 1600px<br>
   * - nobreak: For all viewports.
   * <br>
   * Example:
   * ```{xs: 12, sm: 6, md: 4}```
   */
  @Input() columnNumbers = {};

  /**
   * Object that sets the column offset according to the breakpoint.
   * Breakpoints can be:<br>
   * - xs: From 0px<br>
   * - sm: From 576px<br>
   * - md: From 768px<br>
   * - lg: From 992px<br>
   * - xl: From 1200px<br>
   * - xxl: From 1600px<br>
   * - nobreak: For all viewports.
   * <br>
   * Example:
   * ```{xs: 12, sm: 6, md: 4}```
   */
  @Input() offsets = {};

  // tslint:disable-next-line: variable-name
  protected _columnClasses: string[] = [];

  @HostBinding('class')
  get columnClasses(): string {
    return this._columnClasses.join(' ');
  }

  set(classes: string) {
    this._columnClasses = classes.split(' ');
  }

  ngOnInit() {
    try {
      const columnKeys = Object.keys(this.columnNumbers);
      if (columnKeys.length <= 0) {
        this._columnClasses.push('col');
      }

      columnKeys.forEach(key => {
        if (this.columnNumbers[key] === 'nobreak') {
          this._columnClasses.push(`col-${key}`);
        } else {
          this._columnClasses.push(`col-${key}-${this.columnNumbers[key]}`);
        }
      });

      Object.keys(this.offsets).forEach(key => {
        this._columnClasses.push(`offset-${key}-${this.offsets[key]}`);
      });
    } catch (err) {
      throw new Error(`Malformed \`offsets\` or \`columnNumbers\`: ${err}`);
    }

    if (this.class) {
      this._columnClasses.push(this.class);
    }
  }
}
